import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { publisherTypeOptions } from '@/module/Nomen/PublisherType/model/PublisherTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PublisherTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PublisherTypeSelectControl<T extends FieldValues>(props: PublisherTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(publisherTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
